import styles from "library-react/res/styles"

export default styles;

styles.color.redLabel = "#fe3824";
styles.color.cobalt = "#204f95";
styles.color.fakeWhiteTwo = "#f6f6f6";
styles.color.borderColor = "#979797";
styles.color.error = "#f53993";
